package com.nonopn.skywatcher.design.init

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.compositionLocalOf
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.nonopn.skywatcher.design.loader.LocalLoaderModel
import com.nonopn.skywatcher.design.theme.AppColor
import eu.codlab.viewmodel.rememberViewModel

val LocalLoaderShow =
    compositionLocalOf<LocalLoaderModel> { error("No LocalLoaderShow, check LoaderOverlayWrapper") }

@Composable
fun LoaderOverlayWrapper(
    content: @Composable () -> Unit,
) {
    val loader = rememberViewModel { LocalLoaderModel() }

    CompositionLocalProvider(
        LocalLoaderShow provides loader,
        content = content
    )
}

@Composable
fun LoaderOverlay(
    modifier: Modifier = Modifier
) {
    val model = LocalLoaderShow.current
    val state by model.states.collectAsState()

    if (!state.isVisible) {
        return
    }

    Box(
        modifier = modifier
            .fillMaxSize()
            .background(AppColor.BackgroundDarkBlueSemiTransparent)
            .padding(16.dp)
    ) {
        Row(
            modifier = Modifier
                .align(Alignment.Center)
                .clip(
                    RoundedCornerShape(
                        topStart = 10.dp,
                        topEnd = 10.dp,
                        bottomStart = 10.dp,
                        bottomEnd = 10.dp
                    )
                )
                .heightIn(0.dp, 400.dp) // mention max height here
                .widthIn(0.dp, 800.dp) // mention max width here
        ) {
            CircularProgressIndicator()
        }
    }
}
